<template>
    <div>
        <my-header title="我的收藏" :is-back="true"/>
        <!-- 栏目列表 -->
        <van-tabs color="#4FADF8" :ellipsis="false">
            <!-- 遍历栏目列表 -->
            <van-tab v-for="item in classList" :key="item.id" :title="item.title" :name="item.code">
                <!-- 分页数据 -->
                <van-list
                    v-model:loading="resultData[item.type].loading"
                    :finished="resultData[item.type].finished"
                    finished-text="没有更多了"
                    @load="loadData(item.type)"
                    class="page-list"
                >
                    <!-- 全部 -->
                    <template v-if="item.type === ''">
                        <mix-resource-list :list="resultData[''].list"/>
                    </template>

                    <!-- 富文本 -->
                    <template v-else-if="item.type === 'HTML'">
                        <van-cell-group>
                            <van-cell v-for="r in resultData['HTML'].list" :key="r.id"
                                      :title="r.title" @click="go2Html(r)" icon="column"
                            />
                        </van-cell-group>
                    </template>

                    <!-- 音频 -->
                    <template v-else-if="item.type === 'AUDIO'">
                        <div
                            class="item bottom-20"
                            v-for="r in resultData['AUDIO'].list"
                            :key="r"
                        >
                            <music-item :music="r" @click="go2audio(r)"/>
                        </div>
                    </template>

                    <!-- 其他 -->
                    <template v-else>
                        <resource-list
                            :cover-type="getCoverType(item.type)"
                            :loading="resultData[item.type].loading"
                            :list="resultData[item.type].list"
                        />
                    </template>
                </van-list>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import MyHeader from "@/components/myHeader";
import mixResourceList from "@/components/mixResourceList";
import resourceList from "@/components/resourceList";
import {getUserStarList} from "@/api/CommonApi";
import MusicItem from '@/views/resource/music/components/musicItem';
import {calcBook, calcVideo} from "@/views/personage/CalcResourceHorList";

export default {
    name: "index",
    components:{MyHeader,mixResourceList,resourceList,MusicItem},
    data() {
        return {
            active: 0,
            classList: [
                {id: 0, title: '全部', type: ''},
                {id: 1, title: '文章', type: 'HTML'},
                {id: 2, title: '音频', type: 'AUDIO'},
                {id: 3, title: '视频', type: 'VIDEO'},
                {id: 4, title: '图书', type: 'PDF'},
            ],
            resultData:{}
        }
    },
    created() {
        this.init()
    },
    methods:{
        init(){
            const d = {}
            for(let item of this.classList){
                d[item.type] = {
                    loading:false,
                    finished:false,
                    page:0,
                    list:[],
                }
            }
            this.resultData = d
        },
        loadData(type){
            const data = this.resultData[type]
            type = !type ? null : type;
            getUserStarList({
                pageNum:data.page + 1,
                type
            }).then(res => {
                const result = res.result || {
                    records:[],
                    current:0,
                    pages:0,
                }
                data.finished = true
                data.finished = result.current >= result.pages
                data.page = result.current
                let list = [...data.list,...result.records]
                switch (type){
                    case 'PDF':
                    case 'BOOK':list = calcBook(list);break
                    case 'VIDEO':list = calcVideo(list);break
                }
                data.list = list
            }).finally(() => {
                data.loading = false;
            })
        },
        getCoverType(type){
            switch (type){
                case 'PDF':
                case 'BOOK':return 'book';
                case 'VIDEO':return 'video';
            }
            console.log(type)
        },
        go2Html(r){
            this.$router.push(`/r/article/${r.id}`)
        },
        go2audio(r){
            this.$router.push({
                name:'ResourceMusic',
                params:{
                    id:r.id,
                }
            })
        }
    }
}
</script>

<style scoped>
.page-list{
    margin:0 10px;
}
</style>
